import 'jquery-ui/ui/widgets/selectmenu.js';
import './styles.scss';

$(() => {
	$('.custom-select').selectmenu({
		change: function (event) {
			$(event.target).closest('form').submit();
		}
	});
});